import { AdminProductsService } from '@/services/admin.products.services'

const state = {
  loading: false,
  dialog: false,
  dialogbrand: false,
  dialogcategory: false,
  dialogproduct: false,
  overlay: false,
  brands: [],
  brandselect: [],
  totalbrand: 0,
  categories: [],
  totalcategory: 0,
  products: [],
  selectedproduct: {},
  totalproduct: 0,
  isnewproduk: false,
  selectedbrand: {},
  isnewbrand: false,
  brandgroups: [],
  brandgrouptotal: 0,
  dialogbrandgroup: false,
  selectedbrandgroup: {},
  isnewbrandgroup: false
}
const actions = {
  setdialogbrandgroup ({ commit }, diag) {
    commit('setdialogbrandgroup', diag)
  },
  setselectedbrandgroup ({ commit }, data) {
    commit('setselectedbrandgroup', data)
  },
  setisnewbrandgroup ({ commit }, data) {
    commit('setisnewbrandgroup', data)
  },
  setisnewbrand ({ commit }, data) {
    commit('setisnewbrand', data)
  },
  setselectedbrandgrouplogo ({ commit }, img) {
    commit('setselectedbrandgrouplogo', img)
  },
  setSelectedbrandLogo ({ commit }, img) {
    commit('setselectedbrandlogo', img)
  },
  setselectedbrand ({ commit }, data) {
    commit('setselectedbrand', data)
  },
  setisnewproduct ({ commit }, data) {
    commit('setisnewproduct', data)
  },
  setselectedproduct ({ commit }, data) {
    commit('setselectedproduct', data)
  },
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialogbrand ({ commit }, diag) {
    commit('setdialogbrand', diag)
  },
  setdialogcategory ({ commit }, diag) {
    commit('setdialogcategory', diag)
  },
  setdialogproduct ({ commit }, diag) {
    commit('setdialogproduct', diag)
  },
  tambahProduk ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.tambahproduk(opsi).then(value => {
      commit('setloading', false)
      commit('setdialogproduct', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  editProduk ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.editproduk(opsi).then(value => {
      commit('setloading', false)
      commit('setdialogproduct', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  tambahbrand ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.tambahbrand(opsi).then(value => {
      commit('setloading', false)
      commit('setdialogbrand', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  tambahbrandgroup ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.tambahbrandgroup(opsi).then(value => {
      commit('setloading', false)
      commit('setdialogbrandgroup', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  editbrandgroup ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.editbrandgroup(opsi).then(value => {
      commit('setloading', false)
      commit('setdialogbrandgroup', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  editbrand ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.editbrand(opsi).then(value => {
      commit('setloading', false)
      commit('setdialogbrand', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getBrands ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.getBrands(opsi).then(value => {
      commit('setloading', false)
      commit('setdatabrand', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getBrandSelect ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.getBrandselect(opsi).then(value => {
      commit('setloading', false)
      commit('setdatabrandselect', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getCategory ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.getProductCategory(opsi).then(value => {
      commit('setloading', false)
      commit('setdatacategory', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getProducts ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.getProducts(opsi).then(value => {
      commit('setloading', false)
      commit('setdataproducts', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getBrandGroups ({ dispatch, commit }, opsi) {
    commit('setloading', true)
    AdminProductsService.getBrandGroups(opsi).then(value => {
      commit('setloading', false)
      commit('setBrandGroups', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setdialogbrandgroup (state, s) {
    state.dialogbrandgroup = s
  },
  setselectedbrandgroup (state, s) {
    state.selectedbrandgroup = s
  },
  setisnewbrandgroup (state, s) {
    state.isnewbrandgroup = s
  },
  setBrandGroups (state, s) {
    state.brandgroups = []
    state.brandgroups = s.data.content
    state.brandgrouptotal = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setselectedbrand (state, s) {
    state.selectedbrand = s
  },
  setselectedbrandgrouplogo (state, s) {
    state.selectedbrandgroup.logo = s
  },
  setselectedbrandlogo (state, s) {
    state.selectedbrand.brandlogo = s
  },
  setisnewbrand (state, s) {
    state.isnewbrand = s
  },
  setisnewproduct (state, s) {
    state.isnewproduk = s
  },
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogbrand (state, s) {
    state.dialogbrand = s
  },
  setdialogcategory (state, s) {
    state.dialogcategory = s
  },
  setdialogproduct (state, s) {
    state.dialogproduct = s
  },
  setselectedproduct (state, product) {
    state.selectedproduct = product
  },
  setdatabrand (state, s) {
    state.brands = []
    state.brands = s.data.content
    state.totalbrand = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdatabrandselect (state, s) {
    state.brandselect = []
    state.brandselect = s.data.content
    state.loading = false
    state.overlay = false
  },
  setdatacategory (state, s) {
    state.categories = []
    state.categories = s.data.content
    state.totalcategory = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdataproducts (state, s) {
    state.products = []
    state.products = s.data.content
    state.totalproduct = s.data.totalElements
    state.loading = false
    state.overlay = false
  }
}

export const AdminProducts = {
  namespaced: true,
  state,
  actions,
  mutations
}
